<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-location-search') }}</h5>
                        </div>
                    </div>
                    <div v-if="loading" class="row mt-4 mx-auto">
                        <div class="text-center">
                            <!-- <i class="bx bx-loader bx-lg bx-bx-world align-middle mr-2"></i>  -->
                              <div class="spinner-border text-secondary" role="status" v-if="loading">
                            <span class="sr-only"><p>{{ $t('website.website-location') }}</p></span>
                          </div>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-4" v-if="detailLocation">
                          <div class="col-sm-6">
                              <div class="py-3 px-3">
                                <p v-if="detailLocation.ip_address">  <b>{{ $t('website.ip') }} :</b> {{detailLocation.ip_address}} </p>
                                <p v-if="detailLocation.domain_name">  <b>{{ $t('website.domain_name') }} :</b> {{detailLocation.domain_name}} </p>
                                <p v-if="detailLocation.version">  <b>{{ $t('website.version') }} :</b> {{detailLocation.version}} </p>
                                <p v-if="detailLocation.city">  <b>{{ $t('website.city') }}:</b> {{detailLocation.city}} </p>
                                <p  v-if="detailLocation.region">  <b>{{ $t('website.region') }}:</b> {{detailLocation.region}} </p>
                                <p  v-if="detailLocation.region_code">  <b>{{ $t('website.region_code') }}:</b> {{detailLocation.region_code}}  </p>
                                <p  v-if="detailLocation.icountryp">  <b>{{ $t('website.country') }}:</b> {{detailLocation.country}} </p>
                                <p  v-if="detailLocation.country_name">  <b>{{ $t('website.country_name') }}:</b> {{detailLocation.country_name}} </p>
                                <p  v-if="detailLocation.country_code">  <b>{{ $t('website.country_code') }}:</b>  {{detailLocation.country_code}} </p>
                                <p  v-if="detailLocation.country_code_iso3">  <b>{{ $t('website.country_code_iso3') }}:</b> {{detailLocation.country_code_iso3}} </p>
                                <p  v-if="detailLocation.country_capital">  <b>{{ $t('website.country_capital') }}y:</b> {{detailLocation.country_capital}} </p>
                                <p  v-if="detailLocation.country_tld">  <b>{{ $t('website.country_tld') }}e:</b> {{detailLocation.country_tld}} </p>
                                <p  v-if="detailLocation.continent_code">  <b>{{ $t('website.continent_code') }}:</b> {{detailLocation.continent_code}} </p>
                                <p  v-if="detailLocation.in_eu">  <b>{{ $t('website.in_eu') }}:</b> {{detailLocation.in_eu}}</p>
                                <p  v-if="detailLocation.postal">  <b>{{ $t('website.postal') }}:</b>  {{detailLocation.postal}} </p>
                                <!-- <p  v-if="detailLocation.latitude">  <b>{{ $t('website.latitude') }}:</b>  {{detailLocation.latitude}} </p>
                                <p  v-if="detailLocation.longitude">  <b>{{ $t('website.longitude') }}:</b>  {{detailLocation.longitude}} </p> -->
                                <!-- <p  v-if="detailLocation.timezone">  <b>{{ $t('website.timezone') }}:</b> {{detailLocation.timezone}} </p> -->
                                <p  v-if="detailLocation.utc_offset">  <b>{{ $t('website.utc_offset') }}:</b>  {{detailLocation.utc_offset}} </p>
                                <p  v-if="detailLocation.country_calling_code">  <b>{{ $t('website.country_calling_code') }}:</b>  {{detailLocation.country_calling_code}} </p>
                                <p  v-if="detailLocation.currency">  <b>{{ $t('website.currency') }}s </b>, {{detailLocation.currency}}n </p>
                                <p  v-if="detailLocation.currency_name">  <b>{{ $t('website.currency_name') }}:</b> {{detailLocation.currency_name}} </p>
                                <p  v-if="detailLocation.languages">  <b>{{ $t('website.languages') }}:</b> {{detailLocation.languages}}</p>
                                <p  v-if="detailLocation.country_area">  <b>{{ $t('website.country_area') }}:</b>  {{detailLocation.country_area}} </p>
                                <p  v-if="detailLocation.asn">  <b>{{ $t('website.asn') }}:</b> {{detailLocation.asn}} </p>
                                <p  v-if="detailLocation.org">  <b>{{ $t('website.org') }}:</b> {{detailLocation.org}} </p>
                            </div>
                              
                          </div>
                          <div class="col-sm-6">
                                <div class="card" v-if="detailLocation.latitude">
                                    <gmap-map ref="mymap" :center="{ lat: parseFloat(detailLocation.latitude), lng: parseFloat(detailLocation.longitude) }" :zoom="4" style="height: 40vh">
                                        <gmap-marker
                                        :position="google && new google.maps.LatLng(detailLocation.latitude, detailLocation.longitude)"
                                        ></gmap-marker>
                                    </gmap-map>
                                </div>
                                 <div class="card border pt-2 mt-3" v-if="detailLocation.latitude">
                                   <h5 class="px-3 py-1">{{ $t('website.geo') }}</h5>
                                  <table class="table">
                                      <tr>
                                        <th width="25%" class="text-left">{{ $t('website.city') }}</th>
                                        <td>{{detailLocation.region}}</td>
                                      </tr>
                                        <tr>
                                        <th width="25%" class="text-left">{{ $t('website.country_name') }}</th>
                                        <td>{{detailLocation.country_name}} ({{detailLocation.country_code}})</td>
                                      </tr>
                                      <tr>
                                        <th width="25%" class="text-left">{{ $t('website.coordinates') }}</th>
                                        <td>{{detailLocation.latitude}},  {{detailLocation.longitude}}</td>
                                      </tr>
                                         <tr>
                                        <th width="25%" class="text-left">{{ $t('website.timezone') }}</th>
                                        <td>{{detailLocation.timezone}}</td>
                                      </tr>
                                  </table>
                                </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import {gmapApi} from 'vue2-google-maps';

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: "/find-website",
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            search: false,
            detailLocation: {
                  // "ip": "202.158.15.77",
                  // "version": "IPv4",
                  // "city": "Jakarta",
                  // "region": "Jakarta",
                  // "region_code": "JK",
                  // "country": "ID",
                  // "country_name": "Indonesia",
                  // "country_code": "ID",
                  // "country_code_iso3": "IDN",
                  // "country_capital": "Jakarta",
                  // "country_tld": ".id",
                  // "continent_code": "AS",
                  // "in_eu": false,
                  // "postal": null,
                  // "latitude": -6.1741,
                  // "longitude": 106.8296,
                  // "timezone": "Asia/Jakarta",
                  // "utc_offset": "+0700",
                  // "country_calling_code": "+62",
                  // "currency": "IDR",
                  // "currency_name": "Rupiah",
                  // "languages": "id,en,nl,jv",
                  // "country_area": 1919440.0,
                  // "country_population": 267663435,
                  // "asn": "AS4787",
                  // "org": "PT Cyberindo Aditama"
            },
            total_results:"",
        
            title: this.$t('website.website-location-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-location'),
                href: "/find-website"
                },
                {
                text: this.$t('website.website-location-detail'),
                active: true
                }
            ],
        }
    },
    computed: {  
        google: gmapApi,
        rows() {
            return this.tableData.length;
        },
  },
    watch: { 
        address: {
            handler: function(n, o) {
                console.log(JSON.stringify(n));
                this.count1 = n.count;
            },
            deep: true  
        }
    },
  methods:{
        getLocationWebsite(){
            this.loading = true,
            this.search = true;
            WebsiteService.getWebInfoLocationDetail(this.id)
            .then(response => {
                    this.detailLocation = response.data.data;
                    this.search = true;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
        geocodedAddress(){
            const geocoder = this.google && new google.maps.Geocoder();
            geocoder.geocode( { 'address' : this.address }, function( results, status ) {
                // if( status == google.maps.GeocoderStatus.OK ) {
                    console.log('geocode->',results[0].geometry.location.lat());
                    //In this case it creates a marker, but you can get the lat and lng from the location.LatLng
                    // map.setCenter( results[0].geometry.location );
                    // var marker = new google.maps.Marker( {
                    //     map     : map,
                    //     position: results[0].geometry.location
                    // } );
                // } else {
                //     alert( 'Geocode was not successful for the following reason: ' + status );
                // }
            } );
        },
  },
    mounted(){
      this.getLocationWebsite();
        this.totalRows = this.items.length;  
        // this.listTwitter();]
         this.$watch(()=>this.openMap, () => {
            if (this.openMap == true) {
              var latlong = this.SearchResult.latitude+','+ this.SearchResult.longitude;
                console.log(latlong);
                this.geocodedAddress();
            }
        })
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>